export default function hero() {
	const scrollDownArrow = document.querySelector('.scroll-arrow');
	if (scrollDownArrow) {
		scrollDownArrow.addEventListener('click', () => {
			const testimonial = document.querySelector('.testimonial-section');
			if (testimonial) {
				const offsetTop = testimonial.offsetTop - 20;
				window.scrollTo({
					top: offsetTop,
					behavior: 'smooth',
				});
			}
		});
	}
}
